import PropTypes from "prop-types";
import React from "react";
import "./style.css";
import { Link } from 'react-router-dom';


export const Header_New = () => {
  return (
    <div className="header-menu">
      <div className="header-text-menu"><Link to="/">WeRead</Link></div>
      <div className="menu">
        <nav>
          <div class="navbar">
            <div class="nav-container">
              <input class="checkbox" type="checkbox" name="" id="" />
              <div class="hamburger-lines">
                <span class="line line1"></span>
                <span class="line line2"></span>
                <span class="line line3"></span>
              </div>
              <div class="menu-items">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/bookchoice">Bücherauswahl</Link></li>
                <li><Link to="/explanation">Erklärung</Link></li>
                <li><a href="https://werobots-cottbus.github.io/index.html" target="_blank" rel="noopener noreferrer">WeRobots</a></li>
                <li><a href="https://docs.google.com/forms/d/e/1FAIpQLScjIo_QdN3UIe8y8SQbPgFBpWULn5g_-DpCJsEvq0myWsKZag/viewform" target="_blank" rel="noopener noreferrer">Feedback</a></li>
                <li><Link to="/imprint">Impressum</Link></li>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

